import { render, staticRenderFns } from "./404notfound.vue?vue&type=template&id=12515e68&scoped=true&"
import script from "./404notfound.vue?vue&type=script&lang=js&"
export * from "./404notfound.vue?vue&type=script&lang=js&"
import style0 from "./404notfound.vue?vue&type=style&index=0&id=12515e68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12515e68",
  null
  
)

export default component.exports